export class PratinidhiSabha {
  id: number;
  name: string;
  description: string;
  districtId: number;
  pratinidhiSabhaCode: string;
  districtName: string;
}
